import React, {Fragment} from "react"
import { Link } from "react-router-dom"



const BlockStyleSeven = () => {
    return (
        <Fragment>
            <div className="block-style-seven pl-90 mb-45 pl-md-0">
                <h6 className="sub-title-two mb-20">Sobre Nosotros</h6>
                <h2 className="sect-title mb-20">Hacemos Sistemas de Seguridad para Sitios Web y Apps</h2>
                <p>Estrategizamos continuamente ideas que cumplen con los estándares en lugar de
                    alineaciones basadas en rendimiento. Aprovechamos globalmente soluciones alternativas
                    existentes a través de usuarios virtuales.</p>
                <div className="icon-box">
                    <span><img src="assets/img/icon/icon-28c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-29c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-30c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-31c.svg" alt="icon"/></span>
                    <span><img src="assets/img/icon/icon-32c.svg" alt="icon"/></span>
                </div>
                <Link className="theme_btn mt-55" to="/about">Más Detalles</Link>
            </div>
        </Fragment>
    )
}

export default BlockStyleSeven